/* eslint-disable @typescript-eslint/no-explicit-any */
import { memo, useCallback } from 'react';
import RequestList, { RequestListProps } from './RequestListDesktop';
import { TableManageRequestsActions } from '../tableActions';

export interface ManageRequestListProps
  extends Omit<RequestListProps, 'renderActionColumn'> {
  onVendors: (recordKey: string) => void;
  onComparison: (recordKey: string, taskID?: string) => void;
  onPrevious: (recordKey: string) => void;
  onUpdate: (recordKey: string) => void;
  onExtention: (recordKey: string) => void;
  onView: (recordKey: string) => void;
  onInitiate: (recordKey: string, prFor: string) => void;
  onCancel: (recordKey: string) => void;
  onDelete: (recordKey: string) => void;
  onApprovalHistory?: (requestNo: string) => void;
  showAction?: boolean;
  hidePagination?: boolean;
  isFiltersApplied?: boolean;
  isSearchApplied?: boolean;
}

const ManageRequestList: React.FC<ManageRequestListProps> = (
  props
): JSX.Element => {
  const {
    showAction = true,
    onVendors,
    onComparison,
    onPrevious,
    onUpdate,
    onExtention,
    onView,
    onInitiate,
    onCancel,
    onDelete,
    onApprovalHistory,
    hidePagination = false,
    isFiltersApplied = false,
    isSearchApplied = false,
    ...restProps
  } = props;

  const renderActionColumn = useCallback(
    (_text: any, record: any) => {
      return (
        <TableManageRequestsActions
          status={record.status}
          requestNo={record.tenderNo}
          prFor={record.prFor}
          onView={() => {
            onView(record.key);
          }}
          onRfq={() => {
            onInitiate(record.key, record.prFor);
          }}
          onVendors={() => {
            onVendors(record.key);
          }}
          onComparison={(recordKey: string, taskId: string) =>
            onComparison(recordKey, taskId)
          }
          onPrevious={() => onPrevious(record.key)}
          onUpdate={() => {
            onUpdate(record.key);
          }}
          onExtention={() => {
            onExtention(record.key);
          }}
          onCancel={() => onCancel(record.key)}
          onDelete={() => onDelete(record.key)}
          onApprovalHistory={() => onApprovalHistory?.(record.key)}
          recordKey={record.key}
        />
      );
    },
    [
      onPrevious,
      onView,
      onInitiate,
      onVendors,
      onComparison,
      onUpdate,
      onExtention,
      onCancel,
      onDelete,
      onApprovalHistory,
    ]
  );

  return (
    <RequestList
      {...restProps}
      isFiltersApplied={isFiltersApplied}
      isSearchApplied={isSearchApplied}
      hidePagination={hidePagination}
      renderActionColumn={showAction ? renderActionColumn : undefined}
    />
  );
};

export default memo(ManageRequestList) as typeof ManageRequestList;
